import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import SvgIcon from '../../svg-icon';

const HardwareKeyboardArrowUp = React.createClass({

  mixins: [PureRenderMixin],

  render() {
    return (
      <SvgIcon {...this.props}>
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
      </SvgIcon>
    );
  }

});

export default HardwareKeyboardArrowUp;



/** WEBPACK FOOTER **
 ** ../src/svg-icons/hardware/keyboard-arrow-up.jsx
 **/